import { RouteComponentProps } from "react-router-dom"

export type Id = string

export interface IModel {
  id: Id
  created_at: string
  updated_at: string
}

export type IModelName =
  | "quotes"
  | "orders"
  | "sage_imports"
  | "addresses"
  | "drivers"
  | "customers"
  | "deliveries"
  | "orderRequests"
  | "purchase_orders"
  | "jobs"

export type IPageProps<T extends string | null = null> = T extends string
  ? RouteComponentProps<{ [key in T]: string }>
  : RouteComponentProps

export interface ISkeemRequest {
  model: string
  attributes?: any[]
  filter?: {
    ids?: string[]
    and?: any[]
    scope?: {
      name: string
      params?: {
        query: string
      }
    }
  }
  pagination?: { page: number; perPage: number }
  sort?: { by: string; direction: sortDirections }
}

export type sortDirections = "asc" | "desc"

export interface IBreadCrumb {
  icon?: string
  route: string
  name?: string
}

export type ISkeemChangesItem<T> = { create?: Partial<T>; update?: { id: Id } & Partial<T> }
export type ISkeemChanges<T> = {
  items: ISkeemChangesItem<T>[]
}

export type ILoadingStatus = "loading" | "reFetching" | "errored" | "done"

export type IValidationResponse<T> = { isValid: boolean; errors: T }

export type IFileType = "image" | "file"
export enum fileTypes {
  "image" = "image",
  "file" = "file",
}
